<template>
  <BaseTableView :head="tableHead" list-view="lgAndUp">
    <WorkDocsSchemeTypeTableItem v-for="item in items" :key="item.id" :item="item" />
  </BaseTableView>
</template>

<script>
import WorkDocsSchemeTypeTableItem from 'components/setting/workDocsSchemeType/WorkDocsSchemeTypeTableItem'
export default {
  name: 'WorkDocsSchemeTypeTable',
  props: ['items'],
  components: { WorkDocsSchemeTypeTableItem },
  data() {
    return {}
  },
  computed: {
    tableHead() {
      return [
        {
          text: this.localStorage.translations.pages['setting-scheme_type']['tables']['nazvanie'],
          sort: {
            name: 'name',
            value:
              this.$route.query.sort_param && this.$route.query.sort_param === 'name'
                ? this.$route.query.sort_value && this.$route.query.sort_value === 'desc'
                  ? 'asc'
                  : 'desc'
                : 'desc',
          },
        },
        {text: '', active: true},
      ]
    },
  },
}
</script>
